var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckedIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_211)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.833313,
    y: 0.833252,
    width: 18.3333,
    height: 18.3333,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_332_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13892 10.0001L8.61114 13.4723L15.5556 6.52783",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_211"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_332_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(1.66669 1.66675)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checked_icon.6c7cc283.svg";
export { ForwardRef as ReactComponent };